<div class="tray" [class.free-products-tray]="isFreeProductsTray"
  [class.collapsed]="collapsedFreeProducts && isFreeProductsTray">

  <h2 [class.disabled]="isDisabledDetailCta()">

    <span class="code" (click)="openDetail()">
      {{getCode()}}
      <button *ngIf="!traysService.isGenerallyTrayAllocation(allocationType) && tray.code" class="picture"
        [class.hilighted]="tray.image">
        <img src="./assets/images/picture.svg" alt="camera">
      </button>
    </span>
    <div *ngIf="tray.description" class="description">
      {{tray.description}}
    </div>

    <button *ngIf="!readOnly && traysService.isExtraTrayAllocation(allocationType) && !isFreeProductsTray "
      class="picture" (click)="openDetail(true)" [matTooltip]="'CLONE_TOOLTIP' | translate"
      [matTooltipClass]="'table-tooltip'">
      <img src="./assets/images/copy_icon.svg" alt="copy_icon">
    </button>
    <span *ngIf="tray.products && !isFreeProductsTray" class="counter">
      {{getProductsCounter()}}
    </span>

    <span *ngIf="traysService.isExtraTrayAllocation(allocationType)" class="location-date">
      <span class="location">{{getTrayLocation()}}</span>{{getFormattedReferenceDate(tray.referenceDate)}}
    </span>
  </h2>

  <h2 *ngIf="isFreeProductsTray" class="collapse-cta">
    <button *ngIf="isFreeProductsTray" class="btn-collapse" (click)="collapseFreeProducts()">
      <span *ngIf="collapsedFreeProducts">{{"Show_FREE_PRODUCTS"|translate}}</span>
      <span *ngIf="!collapsedFreeProducts">{{"Hide_FREE_PRODUCTS"|translate}}</span>
      <img src="./assets/images/black_arrow.svg" alt="collapse">
    </button>
    <span *ngIf="tray.products" class="counter">
      {{getProductsCounter()}}
    </span>
  </h2>



  <div [id]="tray.id" class="products" [class.loading]="loading">

    <app-product *ngFor="let product of tray.products" [id]="product.sapCode" [readOnly]="readOnly"
      [class.highlighted]="isHighlighted(product.sapCode)" [product]="parse(product)"
      (handleRemoveProducts)="remove($event)" [allocationType]="allocationType" [isFreeProduct]="isFreeProductsTray"
      [isInBasket]="productsInBasket.includes(product.sapCode)" (handleSelectProduct)="selectProduct($event)"
      [isInCaveau]="tray.code === 'C'">
    </app-product>

    <app-product *ngIf="!(loading && isFreeProductsTray) && !readOnly" [placeholder]="true" class="last"
      (click)="moveProductsHere()" [selectedProductsInBasket]="selectedProductsInBasket.length">
    </app-product>

    <app-loader *ngIf="loading && isFreeProductsTray" position="absolute"></app-loader>

  </div>

</div>
